export const PreferredMaxWidth = 600;
